export default __webpack_public_path__ + "static/media/atease_bg.b5790849.png";